import Brands from "containers/Brands";
import Footer from "containers/Footer";
import Header from "containers/Header";
import QuotationModal from "containers/QuotationModal";
import {
  useAppScroll,
  useAppSection,
  useSmoothScroll,
  useViewportListener,
} from "hooks";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import About from "sections/About";
import Contact from "sections/Contact";
import Home from "sections/Home";
import Projects from "sections/Projects";
import Services from "sections/Services";
import Team from "sections/Team";
import styles from "./styles.module.scss";

const Main: React.FC = () => {
  useSmoothScroll();
  useViewportListener();

  const navigate = useNavigate();
  const section = useAppSection();
  const { scrollTo } = useAppScroll();
  const [isLoaded, setIsLoaded] = useState(false);
  const [previousSection, setPreviousSection] = useState(section);

  useEffect(() => {
    if (!isLoaded) {
      scrollTo({ elementId: section, delay: 600 });
      setIsLoaded(true);
    }
  }, [isLoaded, scrollTo, section]);

  const handleOpenModal = useCallback(() => {
    setPreviousSection(section);
    navigate("/quote");
  }, [navigate, section]);

  const handleCloseModal = useCallback(() => {
    if (previousSection !== "quote") {
      navigate(-1);
    } else {
      navigate("/home");
    }
  }, [navigate, previousSection]);

  return (
    <>
      <div className={styles.container}>
        <Header onOpenQuotationModal={handleOpenModal} />
        <Home onOpenQuotationModal={handleOpenModal} />
        <About />
        <Team />
        <Services />
        <Projects />
        <Contact />
        <Brands />
        <Footer />
      </div>

      <QuotationModal onClose={handleCloseModal} open={section === "quote"} />
    </>
  );
};

export default Main;
